import React from 'react'

import { Heading, Stack } from 'component-library-next'

import { useIntl } from '@app/intl/Intl'
import { Page } from '@app/lib/layout/Page/Page'
import { PageContent } from '@app/lib/layout/Page/PageContent'
import { PageHeader } from '@app/lib/layout/Page/PageHeader'
import { AppointmentsWidget } from '@app/modules/Appointments/AppointmentsWidget'
import { NavBar } from '@app/NavBar/NavBar'

export const AppointmentsPage = () => {
  const { formatMessage } = useIntl()
  return (
    <NavBar title='Termine'>
      <Page>
        <PageHeader>
          <Heading size={Heading.sizes.medium}>
            {formatMessage({ id: 'Lawyer.Appointments.Heading' })}
          </Heading>
        </PageHeader>
        <PageContent>
          <Stack>{<AppointmentsWidget />}</Stack>
        </PageContent>
      </Page>
    </NavBar>
  )
}
